import { Assets } from "@/utils/assets";
import Phaser from "phaser";

export default class LevelLabel extends Phaser.GameObjects.BitmapText{

    constructor(scene: Phaser.Scene){
        super(scene, 0, 0, Assets.FONT1.ID, "LEVEL 1", 25, Phaser.GameObjects.BitmapText.ALIGN_CENTER);
        scene.add.existing(this);
    }

    public update(val: string): void{
        this.setText(`LEVEL ${val}`);
    }

}